{
  "title": "Entrer dans le dojo 🥷",
  "startLabelingButton": "Commençons l'étiquetage 🚀"
}
